import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ProfilePage.css';
import ProfileTabs from './ProfileTabs';
import ProfileSectionContent from './ProfileSectionContent';
import type { ProfileSection } from './types';

interface ProfilePageProps {
	onClose?: () => void;
}

export default function ProfilePage({ onClose }: ProfilePageProps) {
	const { t } = useTranslation('profile');
	const [activeSection, setActiveSection] = useState<ProfileSection>('personal');

	return (
		<section className="profile-page" aria-label={t('page.aria')}>
			{onClose && (
				<button
					className="profile-page__close-button"
					onClick={onClose}
					aria-label={t('page.close_button')}
					title={t('page.close_button')}
				>
					✕
				</button>
			)}
			<div className="profile-page__hero">
				<h2 className="profile-page__title">{t('page.title')}</h2>
			</div>

			<ProfileTabs activeSection={activeSection} onSectionChange={setActiveSection} />

			<div className="profile-page__content">
				<ProfileSectionContent activeSection={activeSection} />
			</div>
		</section>
	);
}